import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="location-selector"
export default class extends Controller {
  static targets = ["latitude","longitude","fulltext"]
  set({ detail: { value } }) {
    const obj = JSON.parse(value);

    this.latitudeTarget.value = obj.y
    this.longitudeTarget.value = obj.x
    this.fulltextTarget.value = obj.fulltext

    this.dispatch("locationSet", { detail: { position: [obj.x, obj.y] } })
  }
}
